<template>
  <v-alert :color="type" :border="border" :outlined="outlined" :width="width">
    <span style="white-space:pre-wrap;">{{message}}</span>
    <slot/>
  </v-alert>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "MessageBox",
    props: {
      type: String,
      message: String,
      outlined: {
        type: Boolean,
        default: true
      },
      width: {
        type: String,
        default: "100%"
      }
    },
    computed: {
      border () {
        if (this.outlined) {
          return undefined;
        }
        return "left";
      }
    }
  }
</script>

<style scoped lang="sass">

</style>
